
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogPage />,
  },
  {
    path: '/producto/:id',
    element: <ProductPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
